import { otherApiClient } from ".";
export const getEntitlements = async (params)=>{
    const { data  } = await otherApiClient.market.get("/entitlements", {
        params
    });
    return data;
};
